import React, { FC } from "react";

import { GoogleBusinessProfile, OnboardingAside, OnboardingContent, PrimaryAlternateControl } from "@xapp/components";

import { OnboardingProps } from "../../models";

export interface ClaimAgentStepProps {
    aside?: React.ReactNode;
    /**
     * Props with place to confirm
     */
    value: OnboardingProps;

    onClaim(props: OnboardingProps): void;
}

export const ClaimAgentStep: FC<ClaimAgentStepProps> = (props) => {
    const { aside, value, onClaim } = props;

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent>
                <GoogleBusinessProfile loading={!value?.place} place={value?.place} showBookOnline={true} />

                <PrimaryAlternateControl labels={{ primary: "Claim Agent" }} onPrimary={onClaim.bind(null, value)} />
            </OnboardingContent>
        </>
    );
};
